import { Component, Input } from '@angular/core';

@Component({
  selector: 'prlw-basis-details-section-info-ui',
  templateUrl: './section-info.component.html',
  styleUrls: ['./section-info.component.scss'],
})
export default class SectionInfoComponent {
  @Input() basisName?: string;
  @Input() manufacturers?: string;
  @Input() stationName?: string;

  @Input() instrumentCode?: string;
  @Input() instrumentName?: string;
  @Input() forecast?: string;
}
